import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import {
  getLatestNewsHighlight,
  getNewsDetail,
  getNewsList,
} from "@/lib/api/generated/endpoints/news/news";

export function latestNewsHighlightQueryOptions() {
  return queryOptions({
    queryKey: ["apex-news", "highlight"],
    queryFn: () => getLatestNewsHighlight(),
    staleTime: 60_000,
  });
}

export function newsListQueryOptions(params: {
  offset: number;
  limit: number;
  search?: string;
  source?: "all" | "ea" | "x";
}) {
  return queryOptions({
    queryKey: ["apex-news", "list", params],
    queryFn: () => getNewsList(params),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}

export function newsDetailQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["apex-news", "detail", slug],
    queryFn: () => getNewsDetail(slug),
    staleTime: 60_000,
  });
}
